import React, { useEffect, useState } from "react";
import { Modal, Button, Container, Card, Col, Row } from "react-bootstrap";
import FormCard from "../common/formCard";
import { FaTimes } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import { GetWorkPlacesFromCompanyServiceFiltered } from "../../Services/workPlaceService";
import { GetIncidentCategoriesService } from "../../Services/incidentCategoryService";
import { GetIncidentFindResponsibleService } from "../../Services/incidentService";


const PopUpSimulateResponsibles = ({ show, handleClose, companyList }) => {

  const [t] = useTranslation("companies")

  const [companyId, setCompanyId] = useState(null);
  const [workplaceId, setWorkplaceId] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [companies, setCompanies] = useState(null);
  const [workplaces, setWorkplaces] = useState(null);
  const [categories, setCategories] = useState(null);
  const [result, setResult] = useState(null);
  const [enabledButton, setEnabledButton] = useState(false)


  const handleClick = async () => {
    let res = await GetIncidentFindResponsibleService(companyId, categoryId, workplaceId)
    setResult(`${res.name} ${res.surname} (${res.nif})`)
  }


  const handleChangeCompanyId = async (value) => {
    setCompanyId(value);
    setWorkplaceId(null);
    setCategoryId(null);
    setEnabledButton(false);

    if (value) {
      let workplacesResult = await GetWorkPlacesFromCompanyServiceFiltered(value);
      let categoriesResult = await GetIncidentCategoriesService(value);
      setWorkplaces(formatWorkplaces(workplacesResult));
      setCategories(categoriesResult);
    } else {
      setWorkplaces(null);
      setCategories(null);
    }
  };



  const handleChangeWorkplaceId = (value) => {
    setWorkplaceId(value);
    if (value && categoryId) {
      setEnabledButton(true);
    } else {
      setEnabledButton(false);
    }
  };

  const handleChangeCategoryId = (value) => {
    setCategoryId(value);
    if (value && (!workplaces || workplaceId)) {
      setEnabledButton(true);
    } else {
      setEnabledButton(false);
    }
  };


  const formatWorkplaces = (workplaces) => {

    const formattedWorkplaces = workplaces.map(workplace => ({
      label: workplace.workplaceName,
      value: workplace.workplaceId
    }));

    return workplaces.length === 0 ? null : formattedWorkplaces;
  };



  useEffect(() => {
    if (companyList && companyList.length > 0) {
      const formattedCompanies = companyList.map(company => ({
        label: company.name,
        value: company.company
      }));
      setCompanies(formattedCompanies);
    }
  }, [companyList]);


  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Body className="popup-after-action-modal-body modal-body-biggest">
          <Container>
            <Card className="mx-auto p-3 rounded-border-px custom-shadow">
              <Card.Body className="d-flex flex-column align-items-center">
                <p className="modal-title mt-2">{`${t("simulatePopUp.title")}`}</p>
                <div className="text-center mt-auto w-100">
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={handleClose}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <Row className="my-5">
                    <Col md={6}>
                      <Col md={12}>
                        <FormCard
                          title={t("simulatePopUp.companies")}
                          type={"select"}
                          options={companies}
                          onChange={(e) =>
                            handleChangeCompanyId(e.value)
                          }
                        />
                      </Col>
                      {companyId && workplaces?.length > 0 && (
                        <Col md={12}>
                          <FormCard
                            key={`workplace-${companyId}`}
                            title={t("simulatePopUp.workplaces")}
                            type={"select"}
                            options={workplaces}
                            value={workplaceId}
                            onChange={(e) =>
                              handleChangeWorkplaceId(e.value)
                            }
                          />
                        </Col>
                      )
                      }
                      {companyId && categories &&
                        <Col md={12}>
                          <FormCard
                            key={`category-${companyId}`}
                            title={t("simulatePopUp.categories")}
                            type={"select"}
                            options={categories}
                            value={categoryId}
                            onChange={(e) =>
                              handleChangeCategoryId(e.value)
                            }
                          />
                        </Col>
                      }

                    </Col>
                    <Col md={6} className="d-flex justify-content-center flex-column">

                      <p className="m-auto fw-bold">
                        {result && <><span className="fw-medium">{t("simulatePopUp.responsible")}</span> <br /> </>}
                        {result || t("simulatePopUp.completeFields")}
                      </p>
                    </Col>
                  </Row>
                  <Button
                    type="submit"
                    className="w-25 mx-auto mt-4 custom-button-primary custom-bg-primary"
                    onClick={handleClick}
                    disabled={!enabledButton}
                  >
                    {`${t("simulatePopUp.simulateButton")}`}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopUpSimulateResponsibles;